<img class="spinner"
     alt="Loading"
     fetchpriority="high"
     [attr.width]="largeSpinner ? 140 : 40"
     [attr.height]="largeSpinner ? 140 : 40"
     src="/content/ux/loading-spinner/assets/loading-spinner.svg" />
